import { HarvestContextProvider } from "./store/HarvestContextProvider";
import { PickupContextProvider } from "./store/PickupContextProvider";
import { DeliveryContextProvider } from "./store/DeliveryContextProvider";
import { OrderContextProvider } from "./store/OrderContextProvider";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { HarvestLogContextProvider } from "./store/HarvestLogContextProvider";
import { UsersContextProvider } from "./store/UsersContextProvider";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import "./Dashboard.css";
import { useCallback, useContext, useEffect } from "react";
import SideMenu from "./components/menu/SideMenu";
import HamburgerMenuButton from "./components/menu/HamburgerMenuButton";
import "./utils/fixLeafletIcons";
import { useAuthUser } from "./hooks/useAuthUser";
import DashboardMenuContent from "./components/menu/DashboardMenuContent";
import { HamburgerMenuContext } from "./store/HamburgerMenuContext";
import { ModalContextProvider } from "./store/ModalContextProvider";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isAuthenticated,
    token,
    detailsLoading,
    role,
    isAdmin,
    isEmployee,
    isSuperUser,
    isBusiness,
    isSocial,
    hasCSASubscription,
  } = useAuthUser();
  const { openHamburgerMenu } = useContext(HamburgerMenuContext);

  const isDashboardIndex =
    location.pathname === "/dashboard" || location.pathname === "/dashboard/";

  const getPageToRender = useCallback(() => {
    if (isAdmin || isSuperUser) return "admin";
    if (isEmployee) return "employee";
    if (isBusiness) return "business";
    if (isSocial && hasCSASubscription) return "client";

    return null;
  }, [
    isAdmin,
    isSuperUser,
    isEmployee,
    isBusiness,
    isSocial,
    hasCSASubscription,
  ]);

  useEffect(() => {
    if (token && detailsLoading) return;
    if (!isAuthenticated) {
      const redirectPath =
        `${location.pathname}${location.search}${location.hash}`.replace(
          /^\//,
          "",
        );
      navigate(
        `/login?redirect=${encodeURIComponent(redirectPath || "dashboard")}`,
      );
      return;
    }
  }, [
    token,
    detailsLoading,
    isAuthenticated,
    location.pathname,
    location.search,
    location.hash,
    navigate,
  ]);

  useEffect(() => {
    const pageToRender = getPageToRender();

    if (!isDashboardIndex || !role) return;
    if (pageToRender) navigate(`/dashboard/${getPageToRender()}`);
  }, [navigate, role, isDashboardIndex, getPageToRender]);

  return (
    <HarvestContextProvider>
      <PickupContextProvider>
        <DeliveryContextProvider>
          <OrderContextProvider>
            <HarvestLogContextProvider>
              <UsersContextProvider>
                <ModalContextProvider>
                  <div className="main">
                    {(isAdmin || isEmployee) && (
                      <>
                        <SideMenu />
                        <div className="fixed-hamburger-btn">
                          <HamburgerMenuButton
                            onClick={() =>
                              openHamburgerMenu(<DashboardMenuContent />)
                            }
                          />
                        </div>
                      </>
                    )}

                    <div className="dashboard-container">
                      <Outlet />
                    </div>
                  </div>
                </ModalContextProvider>
              </UsersContextProvider>
            </HarvestLogContextProvider>
          </OrderContextProvider>
        </DeliveryContextProvider>
      </PickupContextProvider>
    </HarvestContextProvider>
  );
};
export default Dashboard;
